<template>
  <div class="category">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t("label.commune") }}
        </h3>
        <div class="pull-right box-tools">
          <router-link
            v-if="can([Permissions.backend.setting.commune.store])"
            :to="{ name: 'create-commune' }"
            class="btn btn-primary btn-sm"
          >
            <i class="fa fa-plus-circle" /> {{ $t("button.newCommune") }}
          </router-link>
        </div>
      </div>
      <div class="box-body">
        <Datatable
          ref="oTable"
          url="api/backend/commune/datatable"
          :columns="columns"
          table-id="commune-table"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Permissions from '@/permissions'
import Datatable from '@/components/Datatable'

export default {
  name: 'List',
  metaInfo () {
    return {
      title: this.$t('string.communeList'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { Datatable },
  data () {
    return {
      Permissions
    }
  },
  computed: {
    columns () {
      return [
        {
          data: 'name_en',
          name: 'name_en',
          title: this.$t('table.name_en')
        },
        {
          data: 'name_km',
          name: 'name_km',
          title: this.$t('table.name_km')
        },
        {
          data: 'type_' + this.$i18n.locale,
          name: 'type_' + this.$i18n.locale,
          title: this.$t('table.type')
        },
        {
          data: 'created_at',
          name: 'created_at',
          width: '200px',
          searchable: false,
          title: this.$t('table.createdAt'),
          render: (data) => {
            return this.getDateFormat(data)
          }
        },
        {
          data: 'action',
          name: 'action',
          title: this.$t('table.action'),
          width: '120px',
          orderable: false,
          searchable: false
        }
      ]
    }
  },
  mounted () {
    this.loadAction()
  },
  methods: {
    loadAction () {
      const self = this
      this.clearEventHandler([
        '.btn-delete-commune',
        '.btn-edit-commune'
      ])
      $(document).on('click', '.btn-delete-commune', function () {
        self.onDelete($(this).attr('data-id'))
      })
      $(document).on('click', '.btn-edit-commune', function () {
        self.$router.push({
          name: 'edit-commune',
          params: {
            id: $(this).attr('data-id')
          }
        })
      })
    },
    onDelete (id) {
      this.onConfirm({})
        .then((accept) => {
          if (accept) {
            this.$axios.post(process.env.VUE_APP_API + '/api/backend/commune/delete', {
              id: id
            }).then(() => {
              this.showSwalSuccess()
              this.$refs.oTable.draw(true)
            }).catch((error) => {
              this.onResponseError(error)
            })
          }
        })
    }
  }
}
</script>

<style scoped></style>
